var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"transparent","viewBox":"0 0 24 24","width":"24","height":"24"}},[_c('path',{attrs:{"stroke":"#9999A9","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.2","d":"M15.714 6.838a6.276 6.276 0 1 1-8.876 8.876 6.276 6.276 0 0 1 8.876-8.876M19 19l-3.29-3.29"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }